import type { RemediationSelection } from "./components/remediation/RemediationSelection.ts";
import type { ManagedShare } from "./components/report-sharing/useManageAccessForm.ts";

export const BULK_OPERATION_STARTED_EVENT = "bulk-operation-started";

export interface BulkOperationStartedPayload {
    isRowAction: boolean;
    bulkId: string;
    selection?: RemediationSelection;
}

const REPORT_SHARES_NAMESPACE = "reportSharesTableActionProvider";
export const COPY_SHARE_LINK_ACTION = `[${REPORT_SHARES_NAMESPACE}] copy link`;
export const MANAGE_SHARE_ACCESS_ACTION = `[${REPORT_SHARES_NAMESPACE}] manage access`;
export const DELETE_SHARE_ACTION = `[${REPORT_SHARES_NAMESPACE}] delete share`;

export interface CopyShareLinkPayload {
    shareId: string;
    link: string;
}

export interface DeleteSharePayload {
    shareId: string;
    recipientsCount: number;
    isActive: boolean;
}

declare module "@sg-protect/federation-runtime" {
    interface EventMap {
        [BULK_OPERATION_STARTED_EVENT]: BulkOperationStartedPayload;
        [COPY_SHARE_LINK_ACTION]: CopyShareLinkPayload;
        [MANAGE_SHARE_ACCESS_ACTION]: ManagedShare;
        [DELETE_SHARE_ACTION]: DeleteSharePayload;
    }
}
